import React from "react";
import { useLocation } from "react-router-dom";
import {
  Message,
  Checkbox,
  Dropdown,
  Accordion,
  Icon,
  TextArea,
  Header,
} from "semantic-ui-react";
import { Slider } from "react-semantic-ui-range";
import Footer from "./dashboard/Footer";
import bodysignalsOptions from "./bodysignalsOptions";
import genderOptions from "./genderOptions";
import frequencyOptions from "./frequencyOptions";
import durationOptions from "./durationOptions";
import history from "../history";

class ClientForm extends React.Component {
  state = {
    event_id: "organic",
    first_name: "",
    last_name: "",
    gender: "",
    mobile: 0,
    age: 0,
    hrs_sit_per_day: 0,
    hrs_mobile_per_day: 0,
    decreased_productivity: false,
    difficulty_concentrating: false,
    unable_long_hours: false,
    easily_stressed_out: false,
    lose_patience_others: false,
    exhausted_end_of_day: false,
    interrupts_sleep: false,
    moody_and_irritable: false,
    restriction_daily_activities: false,
    hinders_exercise: false,
    unable_to_carry: false,
    activeIndex: null,
    neck_pain_intensity: 0,
    neck_pain_frequency: null,
    neck_pain_duration: null,
    shoulder_stiffness_intensity: 0,
    shoulder_stiffness_frequency: null,
    shoulder_stiffness_duration: null,
    upper_back_intensity: 0,
    upper_back_frequency: null,
    upper_back_duration: null,
    headaches_intensity: 0,
    headaches_frequency: null,
    headaches_duration: null,
    dizziness_intensity: 0,
    dizziness_frequency: null,
    dizziness_duration: null,
    ringing_in_ears_intensity: 0,
    ringing_in_ears_frequency: null,
    ringing_in_ears_duration: null,
    numbness_tingling_intensity: 0,
    numbness_tingling_frequency: null,
    numbness_tingling_duration: null,
    wrist_pain_intensity: 0,
    wrist_pain_frequency: null,
    wrist_pain_duration: null,
    low_back_pain_intensity: 0,
    low_back_pain_frequency: null,
    low_back_pain_duration: null,
    leg_pain_intensity: 0,
    leg_pain_frequency: null,
    leg_pain_duration: null,
    leg_numbness_intensity: 0,
    leg_numbness_frequency: null,
    leg_numbness_duration: null,
    hip_pain_intensity: 0,
    hip_pain_frequency: null,
    hip_pain_duration: null,
    sciatica_intensity: 0,
    sciatica_frequency: null,
    sciatica_duration: null,
    scoliosis_intensity: 0,
    scoliosis_frequency: null,
    scoliosis_duration: null,
    fatigue_intensity: 0,
    fatigue_frequency: null,
    fatigue_duration: null,
    insomnia_intensity: 0,
    insomnia_frequency: null,
    insomnia_duration: null,
    poor_posture_intensity: 0,
    poor_posture_frequency: null,
    poor_posture_duration: null,
    other_symptoms: null,
    tried_pain_medication: false,
    tried_tcm: false,
    tried_massage: false,
    tried_physio: false,
    tried_chiro: false,
    tried_surgery: false,
    tried_na: false,
    tried_others: "",
    achieve_get_answers: false,
    achieve_detect_problems: false,
    achieve_general_awareness: false,
    achieve_understand_chiro: false,
    achieve_others: "",
    formError: false,
    emailError: false,
    mobileError: false,
    isSubmitting: false,
  };

  componentDidMount = () => {
    const params = new URLSearchParams(history.location.search);
    if (params.get("event")) {
      this.setState({ event_id: params.get("event") });
    }
  };

  onInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  // For Accordion to work
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  toggle = (name) =>
    this.setState((prevState) => ({ [name]: !prevState[name] }));

  onFormSubmit = async (event) => {
    event.preventDefault();
    await this.setState({ isSubmitting: true });

    // check if valid email using regex for email
    let re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // console.log(this.state);
    if (re.test(String(this.state.email).toLowerCase())) {
      await this.setState({ emailError: false });
    } else {
      await this.setState({ emailError: true });
    }

    // Check mobile number length
    if (this.state.mobile.length >= 8) {
      await this.setState({ mobileError: false });
    } else {
      await this.setState({ mobileError: true });
    }

    // Check if any errors in form
    if (this.state.mobileError | this.state.emailError) {
      await this.setState({ formError: true });
    } else {
      await this.setState({ formError: false });
    }

    // Render error if there is. Else submit form to backend.
    if (this.state.formError) {
      await this.setState({ isSubmitting: false });
      console.log("Form has error.");
    } else {
      await this.setState({ isSubmitting: false });
      this.props.onFormSubmit(this.state);
    }
  };

  genderOptions = genderOptions;
  bodysignalsOptions = bodysignalsOptions;
  frequencyOptions = frequencyOptions;
  durationOptions = durationOptions;

  renderList(part) {
    let bodySignals = [];
    if (part === 1) {
      bodySignals = [
        {
          id: 0,
          label: "Neck Pain",
          intensity: this.state.neck_pain_intensity,
          intensity_state: "neck_pain_intensity",
          frequency: "neck_pain_frequency",
          duration: "neck_pain_duration",
        },
        {
          id: 1,
          label: "Shoulder Stiffness",
          intensity: this.state.shoulder_stiffness_intensity,
          intensity_state: "shoulder_stiffness_intensity",
          frequency: "shoulder_stiffness_frequency",
          duration: "shoulder_stiffness_duration",
        },
        {
          id: 2,
          label: "Upper Back Pain",
          intensity: this.state.upper_back_intensity,
          intensity_state: "upper_back_intensity",
          frequency: "upper_back_frequency",
          duration: "upper_back_duration",
        },
        {
          id: 3,
          label: "Headaches / Migraines",
          intensity: this.state.headaches_intensity,
          intensity_state: "headaches_intensity",
          frequency: "headaches_frequency",
          duration: "headaches_duration",
        },
      ];
    } else if (part === 2) {
      bodySignals = [
        {
          id: 4,
          label: "Dizziness / Giddiness",
          intensity: this.state.dizziness_intensity,
          intensity_state: "dizziness_intensity",
          frequency: "dizziness_frequency",
          duration: "dizziness_duration",
        },
        {
          id: 5,
          label: "Ringing In Ears",
          intensity: this.state.ringing_in_ears_intensity,
          intensity_state: "ringing_in_ears_intensity",
          frequency: "ringing_in_ears_frequency",
          duration: "ringing_in_ears_duration",
        },
        {
          id: 6,
          label: "Numbness / Tingling In Hands",
          intensity: this.state.numbness_tingling_intensity,
          intensity_state: "numbness_tingling_intensity",
          frequency: "numbness_tingling_frequency",
          duration: "numbness_tingling_duration",
        },
        {
          id: 7,
          label: "Wrist Pain",
          intensity: this.state.wrist_pain_intensity,
          intensity_state: "wrist_pain_intensity",
          frequency: "wrist_pain_frequency",
          duration: "wrist_pain_duration",
        },
      ];
    } else if (part === 3) {
      bodySignals = [
        {
          id: 8,
          label: "Low Back Pain",
          intensity: this.state.low_back_pain_intensity,
          intensity_state: "low_back_pain_intensity",
          frequency: "low_back_pain_frequency",
          duration: "low_back_pain_duration",
        },
        {
          id: 9,
          label: "Leg Pain",
          intensity: this.state.leg_pain_intensity,
          intensity_state: "leg_pain_intensity",
          frequency: "leg_pain_frequency",
          duration: "leg_pain_duration",
        },
        {
          id: 10,
          label: "Leg Numbness / Weakness",
          intensity: this.state.leg_numbness_intensity,
          intensity_state: "leg_numbness_intensity",
          frequency: "leg_numbness_frequency",
          duration: "leg_numbness_duration",
        },
        {
          id: 11,
          label: "Hip Pain",
          intensity: this.state.hip_pain_intensity,
          intensity_state: "hip_pain_intensity",
          frequency: "hip_pain_frequency",
          duration: "hip_pain_duration",
        },
      ];
    } else if (part === 4) {
      bodySignals = [
        {
          id: 12,
          label: "Sciatica",
          intensity: this.state.sciatica_intensity,
          intensity_state: "sciatica_intensity",
          frequency: "sciatica_frequency",
          duration: "sciatica_duration",
        },
        {
          id: 13,
          label: "Scoliosis (S-shape spine)",
          intensity: this.state.scoliosis_intensity,
          intensity_state: "scoliosis_intensity",
          frequency: "scoliosis_frequency",
          duration: "scoliosis_duration",
        },
        {
          id: 14,
          label: "Fatigue / Tiredness",
          intensity: this.state.fatigue_intensity,
          intensity_state: "fatigue_intensity",
          frequency: "fatigue_frequency",
          duration: "fatigue_duration",
        },
        {
          id: 15,
          label: "Insomnia / Sleeping Problems",
          intensity: this.state.insomnia_intensity,
          intensity_state: "insomnia_intensity",
          frequency: "insomnia_frequency",
          duration: "insomnia_duration",
        },
      ];
    } else if (part === 5) {
      bodySignals = [
        {
          id: 16,
          label: "Poor Posture",
          intensity: this.state.poor_posture_intensity,
          intensity_state: "poor_posture_intensity",
          frequency: "poor_posture_frequency",
          duration: "poor_posture_duration",
        },
      ];
    } else {
      bodySignals = [];
    }
    return bodySignals.map((signal) => {
      return (
        <div className="field" key={signal.id}>
          <Accordion styled>
            <Accordion.Title
              active={this.state.activeIndex === signal.id}
              index={signal.id}
              onClick={this.handleClick}
            >
              <Icon name="dropdown" />
              {signal.label}
            </Accordion.Title>
            <Accordion.Content active={this.state.activeIndex === signal.id}>
              <div>Intensity: {signal.intensity}</div>
              <Slider
                discrete
                value={signal.intensity}
                color="red"
                settings={{
                  start: 0,
                  min: 0,
                  max: 5,
                  step: 1,
                  onChange: (value) => {
                    this.setState({ [signal.intensity_state]: value });
                  },
                }}
              />
              {/* <p>where 1 is dull pain and 5 is acute and sharp pain.</p> */}
              <br />
              <label>Frequency</label>
              <Dropdown
                placeholder="How often?"
                fluid
                selection
                clearable
                name={signal.frequency}
                options={this.frequencyOptions}
                onChange={this.handleChange}
              />

              <br />
              <label>How long you have experienced this?</label>
              <Dropdown
                placeholder="How long?"
                fluid
                selection
                clearable
                name={signal.duration}
                options={this.durationOptions}
                onChange={this.handleChange}
              />
            </Accordion.Content>
          </Accordion>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="ui segment">
        <Header
          as="h1"
          textAlign="center"
          image="data:image/png;base64,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"
          content="Spinal Stress Survey Form"
          style={{ marginBottom: "32px" }}
        />

        <Message>
          <p>
            Please complete the following form to help us better understand your
            health concerns and assess your spinal health, which is key to
            maintaining a healthy nervous system and overall quality of life.
          </p>
        </Message>

        <h4 className="ui block header">General Information</h4>
        <form onSubmit={this.onFormSubmit} className="ui form">
          <div className="fields">
            <div className="field">
              <label>First name</label>
              <input
                name="first_name"
                onChange={this.onInputChange}
                type="text"
                placeholder="First Name"
              />
            </div>
            <div className="field">
              <label>Last name</label>
              <input
                name="last_name"
                onChange={this.onInputChange}
                type="text"
                placeholder="Last Name"
              />
            </div>

            <div className="field">
              <input
                hidden
                name="event_id"
                onChange={this.onInputChange}
                type="text"
                placeholder="Event"
              />
            </div>
          </div>

          <div className="fields">
            <div className="field">
              <label>Email</label>
              <input
                name="email"
                onChange={this.onInputChange}
                type="text"
                placeholder="Email Address"
                error={this.state.emailError.toString()}
              />
            </div>
            <div className="field">
              <label>Mobile</label>
              <input
                name="mobile"
                onChange={this.onInputChange}
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Mobile Number"
                error={this.state.mobileError.toString()}
              />
            </div>
            <div className="field">
              <label>Age</label>
              <input
                name="age"
                onChange={this.onInputChange}
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Age"
              />
            </div>

            <div className="field">
              <label>Gender</label>
              <Dropdown
                placeholder="Gender"
                fluid
                selection
                name="gender"
                options={this.genderOptions}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="fields">
            <div className="field">
              <label>Hours seated per day</label>
              <input
                name="hrs_sit_per_day"
                onChange={this.onInputChange}
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Hrs spent sitting daily"
              />
            </div>

            <div className="field">
              <label>Hours of phone usage per day</label>
              <input
                name="hrs_mobile_per_day"
                onChange={this.onInputChange}
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Hrs on mobile phone daily"
              />
            </div>
          </div>
          <br />
          <hr />
          <h1>Symptoms Experienced In The Last 3 Months </h1>
          <h4 className="ui block header">
            Please select the symptoms that apply, with 1 indicating mild
            discomfort and 5 indicating severe discomfort.
            <br />
            <i>
              When your spine is misaligned, it can disrupt your nervous system,
              affecting your body’s ability to heal and function at its best.
              This may lead to various symptoms and health challenges.
            </i>
          </h4>
          <div className="ui four column padded grid">
            <div className="fields four column row">{this.renderList(1)}</div>
            <div className="fields four column row">{this.renderList(2)}</div>
            <div className="fields four column row">{this.renderList(3)}</div>
            <div className="fields four column row">{this.renderList(4)}</div>
            <div className="fields two column row">
              {this.renderList(5)}

              <div className="field">
                <Accordion styled>
                  <Accordion.Title
                    active={this.state.activeIndex === 17}
                    index={17}
                    onClick={this.handleClick}
                  >
                    <Icon name="dropdown" />
                    Others
                  </Accordion.Title>
                  <Accordion.Content active={this.state.activeIndex === 17}>
                    <label>Tell us more</label>
                    <TextArea
                      placeholder="Please describe any other symptoms that you are experiencing."
                      name="other_symptoms"
                      onChange={this.handleChange}
                    />
                  </Accordion.Content>
                </Accordion>
              </div>
            </div>
          </div>

          <hr />
          <h1>Managing the Impact of Your Symptoms </h1>
          <h4 className="ui block header">
            How do your symptoms affect your daily life?
            <br />
            <i>
              Spinal misalignment can affect more than just your comfort — it
              may interfere with your daily activities, mobility, and overall
              health.
            </i>
          </h4>

          <div className="ui four column padded grid">
            <div className="fields four column row">
              <div className="field">
                <Checkbox
                  label="Decreased productivity"
                  onChange={() => this.toggle("decreased_productivity")}
                  checked={this.state.decreased_productivity}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Difficulty concentrating"
                  onChange={() => this.toggle("difficulty_concentrating")}
                  checked={this.state.difficulty_concentrating}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Unable to work long hours"
                  onChange={() => this.toggle("unable_long_hours")}
                  checked={this.state.unable_long_hours}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Easily stressed out"
                  onChange={() => this.toggle("easily_stressed_out")}
                  checked={this.state.easily_stressed_out}
                />
              </div>
            </div>

            <div className="fields four column row">
              <div className="field">
                <Checkbox
                  label="Lose patience with others"
                  onChange={() => this.toggle("lose_patience_others")}
                  checked={this.state.lose_patience_others}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Exhausted at the end of the day"
                  onChange={() => this.toggle("exhausted_end_of_day")}
                  checked={this.state.exhausted_end_of_day}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Interrupts your sleep"
                  onChange={() => this.toggle("interrupts_sleep")}
                  checked={this.state.interrupts_sleep}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Moody and/or irritable"
                  onChange={() => this.toggle("moody_and_irritable")}
                  checked={this.state.moody_and_irritable}
                />
              </div>
            </div>

            <div className="fields four column row">
              <div className="field">
                <Checkbox
                  label="Restriction in daily activities"
                  onChange={() => this.toggle("restriction_daily_activities")}
                  checked={this.state.restriction_daily_activities}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Hinders ability to exercise or participate in sports"
                  onChange={() => this.toggle("hinders_exercise")}
                  checked={this.state.hinders_exercise}
                />
              </div>
              <div className="field">
                <Checkbox
                  label="Unable to carry children / heavy items for long periods"
                  onChange={() => this.toggle("unable_to_carry")}
                  checked={this.state.unable_to_carry}
                />
              </div>
            </div>
          </div>
          <br />
          <h4 className="ui block header">
            What have you done to manage your symptoms?
          </h4>

          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Pain medication (e.g. Panadol)"
                onChange={() => this.toggle("tried_pain_medication")}
                checked={this.state.tried_pain_medication}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Traditional Chinese Medicine"
                onChange={() => this.toggle("tried_tcm")}
                checked={this.state.tried_tcm}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Massage"
                onChange={() => this.toggle("tried_massage")}
                checked={this.state.tried_massage}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Physiotherapy"
                onChange={() => this.toggle("tried_physio")}
                checked={this.state.tried_physio}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Chiropractic"
                onChange={() => this.toggle("tried_chiro")}
                checked={this.state.tried_chiro}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Surgery"
                onChange={() => this.toggle("tried_surgery")}
                checked={this.state.tried_surgery}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Did not seek treatment"
                onChange={() => this.toggle("tried_na")}
                checked={this.state.tried_na}
              />
            </div>
          </div>
          <div className="field">
            <label>Others</label>

            <TextArea
              label="Others"
              placeholder="Please describe any other treatments that you have tried."
              name="tried_others"
              onChange={this.handleChange}
            />
          </div>

          <br />
          <h4 className="ui block header">
            What do you hope to achieve from this screening?
          </h4>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Get answers to my body aches and pains"
                onChange={() => this.toggle("achieve_get_answers")}
                checked={this.state.achieve_get_answers}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Detect potential problems before they become serious"
                onChange={() => this.toggle("achieve_detect_problems")}
                checked={this.state.achieve_detect_problems}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="General awareness about my health"
                onChange={() => this.toggle("achieve_general_awareness")}
                checked={this.state.achieve_general_awareness}
              />
            </div>
          </div>
          <div className="fields one column row">
            <div className="field">
              <Checkbox
                label="Understand more about chiropractic"
                onChange={() => this.toggle("achieve_understand_chiro")}
                checked={this.state.achieve_understand_chiro}
              />
            </div>
          </div>

          <div className="field">
            <label>Others</label>

            <TextArea
              label="Others"
              placeholder="Please describe any other objectives you are hoping to achieve."
              name="achieve_others"
              onChange={this.handleChange}
            />
          </div>

          <br />

          <div className="field" style={{ textAlign: "center" }}>
            <Message>
              <h4>
                A well-aligned spine supports not just your overall health but
                also your energy level, performance at work and overall quality
                of life. Taking care of your spinal health can lead to a more
                vibrant and productive life.
              </h4>
            </Message>
          </div>

          <br />

          <p align="right">
            <button
              className="ui primary button"
              type="submit"
              disabled={this.state.isSubmitting || this.props.api_isSubmitting}
            >
              Submit
            </button>
          </p>
        </form>
        {this.state.formError ? (
          <Message
            error
            header="Oops! There was an issue."
            content={
              this.state.mobileError
                ? "Please check that your mobile number has at least 8 digits before submitting."
                : "Please check that you have entered a valid email address before submitting."
            }
          />
        ) : null}

        <br />

        <Footer />
      </div>
    );
  }
}

export default ClientForm;
